import React from "react";
import { useNavigate } from "react-router-dom";

const PaginaEroare = () => {
  const navigate = useNavigate();

  const mergiAcasa = () => {
    navigate("/");
  };

  return (
    <div style={stiluri.container}>
      <div style={stiluri.content}>
        <img
          src="https://www.svgrepo.com/show/176343/error-page.svg"
          alt="Eroare 404"
          style={stiluri.imagine}
        />
        <h1 style={stiluri.titlu}>Ups! Ceva nu a mers bine.</h1>
        <p style={stiluri.mesaj}>
          Pagina pe care o cauți nu există sau a apărut o eroare.
        </p>
        <button style={stiluri.buton} onClick={mergiAcasa}>
          Înapoi la Acasă
        </button>
      </div>
    </div>
  );
};

const stiluri = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f2f6fc",
    color: "#2c3e50",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "2rem",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    borderRadius: "10px",
    backgroundColor: "#ffffff",
    maxWidth: "500px",
    textAlign: "center",
    animation: "fadeIn 0.8s ease-in-out",
  },
  imagine: {
    width: "150px",
    marginBottom: "1.5rem",
  },
  titlu: {
    fontSize: "2.5rem",
    marginBottom: "1rem",
    color: "#333",
  },
  mesaj: {
    fontSize: "1.2rem",
    marginBottom: "1.5rem",
    color: "#555",
  },
  buton: {
    padding: "0.8rem 1.5rem",
    fontSize: "1rem",
    color: "#fff",
    backgroundColor: "#007bff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    boxShadow: "0 4px 6px rgba(0, 123, 255, 0.3)",
    transition: "all 0.3s ease",
  },
  "@keyframes fadeIn": {
    "0%": { opacity: 0 },
    "100%": { opacity: 1 },
  },
};

export default PaginaEroare;
